import * as React from "react";
const IconChat = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.8589 8.16519C20.5849 9.38938 22.4863 12.1536 22.4863 15.3674V18.7424C22.4863 19.9851 21.4914 20.9924 20.2641 20.9924H13.5974C10.6947 20.9924 8.22531 19.1141 7.31012 16.4924M17.8589 8.16519C17.1574 5.19809 14.5207 2.99243 11.3752 2.99243H10.2641C5.96856 2.99243 2.48633 6.51819 2.48633 10.8674V14.2424C2.48633 15.4851 3.48125 16.4924 4.70855 16.4924H7.31012M17.8589 8.16519C17.9785 8.67118 18.0419 9.19932 18.0419 9.74243C18.0419 13.4704 15.0571 16.4924 11.3752 16.4924H7.31012"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);
export default IconChat;
